import { useState } from 'react';
import {
   Box,
   Card,
   CardContent,
   Checkbox,
   Collapse,
   Divider,
   FormControlLabel,
   FormHelperText,
   IconButton,
   Stack,
   Typography,
   Chip,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const humanize = (text) =>
   text
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());

const ModuleCard = ({ module, checked, selectedModule, toggleModule, togglePermission }) => {
   const [expanded, setExpanded] = useState(checked);

   const selectedCount = selectedModule?.permissionIds?.length || 0;
   console.log(module, 'modulesss');
   return (
      <Card
         elevation={0}
         sx={{
            borderRadius: 3,
            border: checked ? '2px solid #1976d2' : '1px solid #E5E7EB',
            transition: '.25s',
            overflow: 'hidden',
            '&:hover': {
               borderColor: '#1976d2',
            },
         }}
      >
         <CardContent sx={{ pb: checked ? 2 : '16px !important' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
               <FormControlLabel
                  sx={{ m: 0 }}
                  control={
                     <Checkbox
                        checked={checked}
                        onChange={() => {
                           toggleModule(module);
                           if (!checked) {
                              setExpanded(true);
                           } else {
                              setExpanded(false);
                           }
                        }}
                     />
                  }
                  label={
                     <Box>
                        <Typography fontWeight={600} fontSize={15}>
                           {humanize(module?.moduleName)}
                        </Typography>

                        <Typography variant="caption" color="text.secondary">
                           {module?.permissions?.length} permissions
                        </Typography>
                     </Box>
                  }
               />

               <Box display="flex" alignItems="center" gap={1}>
                  {checked && selectedCount > 0 && (
                     <Chip color="primary" size="small" label={`${selectedCount} Selected`} />
                  )}

                  {checked && (
                     <IconButton onClick={() => setExpanded(!expanded)}>
                        {expanded ? <ExpandLess /> : <ExpandMore />}
                     </IconButton>
                  )}
               </Box>
            </Box>

            <Collapse in={checked && expanded}>
               <Divider sx={{ my: 2 }} />

               <Stack spacing={1}>
                  {module.permissions.map((permission) => {
                     const isChecked =
                        selectedModule?.permissionIds?.includes(permission.id) || false;

                     return (
                        <FormControlLabel
                           key={permission.id}
                           control={
                              <Checkbox
                                 checked={isChecked}
                                 onChange={() => togglePermission(module?.moduleId, permission?.id)}
                              />
                           }
                           label={
                              <Typography fontSize={14}>{humanize(permission?.name)}</Typography>
                           }
                        />
                     );
                  })}
               </Stack>

               {checked && selectedModule?.permissionIds.length === 0 && (
                  <FormHelperText error sx={{ mt: 1 }}>
                     Select at least one permission for this module.
                  </FormHelperText>
               )}
            </Collapse>
         </CardContent>
      </Card>
   );
};

export default ModuleCard;
